import React from "react";
import './CaseStudies.css';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Collapse, Button } from '@chakra-ui/react'
import { MinusIcon, AddIcon } from '@chakra-ui/icons'
import verticalMonitors from '../../assets/img/vertical-monitors-tribex.png';
import curvedMonitor from '../../assets/img/fng-curved-monitor.png';
import tribexPrint from '../../assets/img/tribex-print.jpg';
import freaksPrint from '../../assets/img/freaks-guilds-print.jpg';
import { AnimationOnScroll } from 'react-animation-on-scroll';


export default class CaseStudies extends React.Component {

	constructor(props){
		super(props)
		this.state = {
			isTribexExpanded: false,
			isFreaksExpanded: false,
			delay: 300
		}
	}

	componentDidMount(){
		let delay = window.innerWidth < 769?0:300;
		this.setState({delay:delay})
	}

	render() {
		const FREAKS_EXAMPLE_1 = "https://etherscan.io/tx/0x20c997f22cc7b402f4ec3d5b3848eeb29591f4e5e7cb56dd67da9d9c31d4e0ad"
		const FREAKS_EXAMPLE_2 = "https://polygonscan.com/tx/0x381fd2ef0ac338ff5905611c1733842c2ee483f57f38e552a75f21b7f9281b8d"

		return (
		<div id="case-studies" className="case-studies-container">

			<AnimationOnScroll initiallyVisible={false} animateIn="fadeDown" animateOnce={true} delay={0}>
				<div className="section-briefing">
					<h1 className="section-title">RECENT CASE STUDIES</h1>
					<div className="briefing-text">
						<p>
							Helping others to make their projects successful in Web3
						</p>
					</div>
				</div>
			</AnimationOnScroll>

			<AnimationOnScroll initiallyVisible={false} animateIn="fadeUp" animateOnce={true} delay={0}>
				<div className="section-row blue-gradient">
					<div className="section-text text-left">
						<AnimationOnScroll initiallyVisible={false} animateIn="fadeRight" animateOnce={true} delay={this.state.delay}>
							<div className="section-text-content">
							<h1 className="showcase-title item-title">TRIBEX</h1>
								<div className="showcase-text">
									<p className="item-subhead">CODE REPO + SMART CONTRACT VALIDATION</p>
									<p className="item-body showcase-dscription">A disastrous hack on an amazing project, our team helped validate the smart contract that powered the TribeX mint. We provided a code repo of a comprehensive test suite, open-sourced the code and shared the results with the project and their community.</p>
									<Button variant={this.state.isTribexExpanded?'outlineBlue':'outlineBlueAnimated'} leftIcon={this.state.isTribexExpanded?<MinusIcon />:<AddIcon />} onClick={()=>{this.setState({isTribexExpanded:!this.state.isTribexExpanded})}}>
										{this.state.isTribexExpanded?'SHOW LESS':'SHOW MORE'}
									</Button>
								</div>
							</div>
						</AnimationOnScroll>
					</div>
					<div className="section-image image-right">
						<AnimationOnScroll initiallyVisible={false} animateIn="fadeLeft" animateOnce={true} delay={this.state.delay}>
							<img className="tribex-img fade-to-black" src={verticalMonitors} alt=""/>
						</AnimationOnScroll>
					</div>
					<div className="section-accordion-container tribex-accordion mobile-white-border white-border">
						<Collapse in={this.state.isTribexExpanded}>
							<div className="expanded-accordion">
								<div className="tribex-text">
									<p className="item-subhead">SUCCESSFUL BATTERY OF TESTS</p>
									<p className="item-body">Our test suite provided the needed validation for the project to resume the mint assured that the smart contract was not the source vulnerability.</p>
									<p className="item-body">We even received an honorary NFT created specially as an homage to the open arms format of our own Wall St Fam collection.</p>
								</div>
								<div className="tribex-print"><img className="print-border" src={tribexPrint} alt="" /></div>
							</div>
						</Collapse>
					</div>
				</div>
			</AnimationOnScroll>

			<AnimationOnScroll initiallyVisible={false} animateIn="fadeUp" animateOnce={true} delay={0}>
				<div className="section-row blue-gradient section-image-first">
					<div className="section-image image-left">
						<AnimationOnScroll initiallyVisible={false} animateIn="fadeRight" animateOnce={true} delay={this.state.delay}>
							<img className="freaks-img fade-to-black" src={curvedMonitor} alt=""/>
						</AnimationOnScroll>
					</div>
					<div className="section-text text-right">
						<AnimationOnScroll initiallyVisible={false} animateIn="fadeLeft" animateOnce={true} delay={this.state.delay}>
							<div className="section-text-content freaks-text">
								<h1  className="item-title">FREAKS N' GUILDS</h1>
								<div className="showcase-text" style={this.state.isFreaksExpanded?{height:'100%'}:{height:'auto'}}>
									<p className="item-subhead">CREATING A CUTTING EDGE BRIDGE BETWEEN 2 BLOCKCHAINS</p>
									<p className="item-body showcase-description">We architected and implemented a solution (called bi-directional bridge) that allows users to convert their Ethereum assets (ERC-20, ERC-721) to Polygon. Users can then play on Polygon for roughly 2000x less fees.</p>
									<Button variant={this.state.isFreaksExpanded?'outlineBlue':'outlineBlueAnimated'} leftIcon={this.state.isFreaksExpanded?<MinusIcon />:<AddIcon />} onClick={()=>{this.setState({isFreaksExpanded:!this.state.isFreaksExpanded})}}>
										{this.state.isFreaksExpanded?'SHOW LESS':'SHOW MORE'}
									</Button>
								</div>
							</div>
						</AnimationOnScroll>
					</div>
					<div className="section-accordion-container">
						<Collapse in={this.state.isFreaksExpanded}>
							<div className="expanded-accordion divided-accordion" >
								<div className="freaks-print-container mobile-white-border">
									<img className="print-border" src={freaksPrint} alt="" />
								</div>
								<div className="freaks-text-accordion white-border">
									<div>
										<p className="item-subhead">BI-DIRECTIONAL CONNECTIONS</p>
										<p className="item-body">Users are also able to convert their Polygon assets back onto Ethereum so that they can sell and trade their NFTs and ERC-20 tokens at more popular marketplaces such as OpenSea, where Ethereum NFTs have more worth than in Polygon and have a higher congregation of traders.</p>
									</div>
									<div>
										<p className="item-subhead">20x FASTER THAN PEERS</p>
										<p className="item-body">As a result of our work, Freaks N' Guilds' new bi-directional bridge achieved a performance 20x faster than their peers in on-chain NFT RPG Gaming.</p>
										<p className="item-body">Example transactions <a className="example-link" href={FREAKS_EXAMPLE_1} target="_blank" rel="noreferrer">here</a> and <a className="example-link" href={FREAKS_EXAMPLE_2} target="_blank" rel="noreferrer">here</a></p>
									</div>
									<div>
										<p className="item-subhead">AND ANOTHER PROJECT JOINING BEYOND RARITY</p>
										<p className="item-body">The team also joined Beyond Rarity (Previously VibeRater) as it gave them control over their collection unlike other rarity tools available.</p>
									</div>
								</div>
							</div>
						</Collapse>
					</div>
				</div>
			</AnimationOnScroll>
		</div>
		);
	}
}
